import { ChatGroupId } from '@/chat/models/ChatGroup';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { UserId } from '@/shared/models/User';
import CleaningTask from '../models/CleaningTask';
import { ABSTRACT_SCHEMA } from './taskConverters';
import { parseTags } from '@/shared/converters/tagConverters';

const SCHEMA = {
  ...ABSTRACT_SCHEMA,
  assignedUserId: parseAssignedUserId,
  assignedGroupId: parseAssignedGroupId,
  exteriorCleaningStatus: 'cleaningStatus',
  interiorCleaningStatus: 'interiorCleaningStatus',
  isDelivery: 'isDelivery',
  tags: (data: any) => parseTags(data.tags),
};

function parseAssignedUserId(data: any): UserId | null {
  const { assignedTo } = data;
  if (assignedTo && !assignedTo.isGroup) return assignedTo.id;
  return null;
}

function parseAssignedGroupId(data: any): ChatGroupId | null {
  const { assignedTo } = data;
  if (assignedTo?.isGroup) return assignedTo.id;
  return null;
}

export function parseCleaningTask(data: any): CleaningTask | null {
  return parseEntity(data, SCHEMA, CleaningTask);
}

export function parseCleaningTasks(data: any): Array<CleaningTask> {
  return parseEntities(data, SCHEMA, CleaningTask);
}